import React, { useEffect, useState } from "react";
import { ChevronRight, ClipboardList, Hash } from "lucide-react";
import { Link, useNavigate, useParams } from "react-router-dom";
import AdminLayout from "../components/AdminLayout";
import ProjectActionDialog from "../components/ProjectActionDialog";
import apiClient, { getFriendlyErrorMessage } from "../../../app/apiClient";
import { normalizeProject } from "./projectDirectory";
import "./ProjectDetails.css";

export default function AddProjectUpdate() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [project, setProject] = useState(null);
  const [error, setError] = useState("");
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    let active = true;
    setProject(null); setError("");
    apiClient.get("/admin/project/" + encodeURIComponent(id)).then(({ data }) => {
      const raw = data?.project || data?.data || data;
      if (!raw || typeof raw !== "object" || Array.isArray(raw)) throw new Error("Project not found.");
      if (active) setProject(normalizeProject({ ...raw, id: raw.id ?? id }));
    }).catch((failure) => { if (active) setError(getFriendlyErrorMessage(failure, "Unable to load project.")); });
    return () => { active = false; };
  }, [id, attempt]);
  const detailPath = "/admin/projects/" + encodeURIComponent(id);
  const breadcrumb = <nav className="detail-breadcrumb" aria-label="Breadcrumb"><Link to="/admin/dashboard">Admin</Link><ChevronRight size={13} /><Link to="/admin/projects">Projects</Link><ChevronRight size={13} /><Link to={detailPath}>{project?.projectCode || id}</Link><ChevronRight size={13} /><strong aria-current="page">Add Update</strong></nav>;
  const back = (success) => navigate(detailPath, { replace: true, state: { tab: "Updates", success } });
  return <AdminLayout activeItem="Projects" breadcrumb={breadcrumb}><div className="project-detail-page add-project-update">
    <div className="update-page-heading"><div><p className="update-eyebrow"><ClipboardList size={13} />PROJECT UPDATE</p><h1>Add Project Update</h1><p>Share the latest construction progress{project ? " for " + project.projectName : ""}.</p></div>{project && <span className="update-project-code"><Hash size={13} />{project.projectCode}</span>}</div>
    {error ? <div className="detail-state" role="alert"><p>{error}</p><button className="detail-button" onClick={() => setAttempt((value) => value + 1)}>Try again</button></div> : !project ? <p className="detail-empty">Fetching project...</p> : <ProjectActionDialog key={project.id} action="update" project={project} embedded onClose={() => back("")} onSaved={() => back("Update posted successfully.")} />}
  </div></AdminLayout>;
}
